export default __webpack_public_path__ + "static/media/148.1af2be73.png";